__turbopack_context__.v({
  "footerColumn": "ObawWa_footerColumn",
  "footerRow": "ObawWa_footerRow",
});
